module.exports = __webpack_public_path__ + "static/media/speaker.36d77d80.png";